import { render, staticRenderFns } from "./DashboardGroupShareModal.vue?vue&type=template&id=74a2bd16&"
import script from "./DashboardGroupShareModal.vue?vue&type=script&lang=js&"
export * from "./DashboardGroupShareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports